export default __webpack_public_path__ + "static/media/blackPencilIcon.c556422e.svg";